module.exports = __webpack_public_path__ + "static/img/ket-renewal-mobile-sub-01@m.5b96394.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ket-renewal/ket-renewal-mobile-sub-01@m.png
// module id = uUvG
// module chunks = 0